import { useNavigate } from 'react-router';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';

export const useChangeEmail = (): any => {
  const navigate = useNavigate();

  const { error, send, isLoading, status } = useRequest({
    url: '/api/v1/auth/me/confirmChangeEmail',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const changeEmail = async (body: { hash: string }) => {
    const accessToken = await storageService.getItem('accessToken');
    const refreshToken = await storageService.getItem('refreshToken');
    if (!accessToken || !refreshToken) return;
    if (body.hash) {
      send({ ...body }).then();
    }
  };

  if (!error && status === 200) {
    storageService.removeItem('accessToken');
    storageService.removeItem('refreshToken');
    navigate('/auth/login', { replace: true });
  }

  return { changeEmail, isLoading, error };
};
